import { ICONS, Icon, Table, Typography } from '@thinknet-gmbh/platform-common-ui';
import { Select } from 'antd';
import { useGetEmployeeWorkload } from 'src/hooks/dashboard/get-workload.hook';
import moment from 'moment';
import { useState } from 'react';
import lowerCase from 'lodash/lowerCase';
import {
  HeaderContainer,
  SelectWrapper,
  TableContainer,
  TableHeaderContainer,
  TableHeaderLeftContainer,
  WidgetContainer,
} from './widgets.styles';
import { getYears } from './widgets.helpers';

const HoursWithPercentsC = ({ inputText }: { inputText: string }) => {
  const text = inputText ? inputText.split('-') : 0;
  return text !== 0 ? (
    <Typography>
      {text[0]}
      <Icon icon={ICONS.percentDivider} leftMargin />
      {text[1]}
    </Typography>
  ) : (
    <Typography>{text}</Typography>
  );
};

const WorkloadWidgetContainer = ({ t }: { t: Function }) => {
  const { currentYear, years } = getYears();
  const [year, setYear] = useState(currentYear);

  const startDate = moment(year, 'YYYY').startOf('year').toDate();
  const endDate = moment(year, 'YYYY').endOf('year').toDate();

  const { monthlyWorkload, loading } = useGetEmployeeWorkload(startDate, endDate, year);

  return (
    <WidgetContainer>
      <HeaderContainer>
        <TableHeaderContainer>
          <TableHeaderLeftContainer>
            <Icon icon={ICONS.workload} />
            <Typography weight="bold">{t('labels.workload')}</Typography>
          </TableHeaderLeftContainer>
          <SelectWrapper>
            <Select defaultValue={currentYear} onChange={value => setYear(value)}>
              {years.map(year => (
                <Select.Option key={`year-${year}`} value={year}>
                  {year}
                </Select.Option>
              ))}
            </Select>
          </SelectWrapper>
        </TableHeaderContainer>
      </HeaderContainer>
      <TableContainer>
        <Table
          dataSource={Object.values(monthlyWorkload)}
          loading={loading}
          rowKey={record => record.monthName}
        >
          <Table.Column
            title={t('table.tabs.employee')}
            key="employee"
            dataIndex="monthName"
            render={monthName => (
              <Typography>{t(`table.months.${lowerCase(monthName)}`)}</Typography>
            )}
          />
          <Table.Column
            title={t('table.tabs.capacity')}
            key="capacity"
            dataIndex="capacity"
            render={capacity => <Typography>{`${capacity} Std.`}</Typography>}
          />
          <Table.Column
            title={t('table.tabs.planned')}
            key="planned"
            dataIndex="plannedWithPercents"
            render={planned => <HoursWithPercentsC inputText={planned} />}
          />
          <Table.Column
            title={t('table.tabs.confirmed')}
            key="confirmed"
            dataIndex="confirmedWithPercents"
            render={confirmed => <HoursWithPercentsC inputText={confirmed} />}
          />
        </Table>
      </TableContainer>
    </WidgetContainer>
  );
};

export default WorkloadWidgetContainer;
